<template>
  <div>
    <div class="accountMain">
      <el-tabs type="border-card" v-model="activeName" @tab-click="changetab">
        <el-tab-pane label="订单流水" name="assembly"> </el-tab-pane>
        <el-tab-pane label="收支统计" name="assemblyStorage">
          <div class="searchTabs">
            <el-radio-group
              v-model="accountFrom.type"
              @change="changeRadio"
              size="small"
            >
              <el-radio-button label="year">年</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
              <el-radio-button label="customize">自定义</el-radio-button>
            </el-radio-group>
            <el-date-picker
              size="small"
              v-model="accountFrom.dateStart"
              type="year"
              placeholder="选择年"
              v-show="accountFrom.type == 'year'"
              class="ml20"
              format="yyyy"
              value-format="yyyy"
            >
            </el-date-picker>
            <el-date-picker
              size="small"
              v-model="accountFrom.dateStart"
              type="month"
              placeholder="选择月"
              v-show="accountFrom.type == 'month'"
              class="ml20"
              format="yyyy-MM"
              value-format="yyyy-MM"
            >
            </el-date-picker>

            <el-date-picker
              size="small"
              v-model="accountFrom.dateStart"
              type="date"
              placeholder="选择开始日期"
              v-show="accountFrom.type == 'customize'"
              class="ml20"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <span v-show="accountFrom.type == 'customize'" class="mp">至</span>
            <el-date-picker
              size="small"
              v-model="accountFrom.dateEnd"
              type="date"
              placeholder="选择结束日期"
              v-show="accountFrom.type == 'customize'"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-select
              filterable
              clearable
              class="ml20"
              v-model="accountFrom.shopId"
              size="small"
              placeholder="门店筛选"
              :disabled="showshopId"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <el-button
              type="primary"
              @click="accountSearch"
              class="ml20"
              size="small"
            >
              搜索
            </el-button>
            <el-button
              type="primary"
              class="ml15"
              size="small"
              @click="copyOut"
            >
              导出
            </el-button>
          </div>
          <div class="dFlex">
            <div class="colorRed fz18 ml20">
              收入:{{ format_number(totalRevenue) }}元
            </div>
            <div class="colorGreen fz18 ml20">
              支出:{{ format_number(totalExpenses) }}元
            </div>
            <div class="colorBlack fz18 ml20">
              合计:{{ format_number(cashSurplus) }}元
            </div>
          </div>
          <el-row class="rowWidth">
            <el-col :span="8">
              <div id="main" style="width: 600px; height: 400px"></div>
              <el-table
                :data="intList"
                v-loading="loading"
                style="width: 80%; margin-left: 15%; margin-top: 25px"
              >
                <el-table-column
                  prop="categoryName"
                  label="类型"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="totalMoney"
                  label="金额(元)"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ format_number(scope.row.totalMoney) }}
                  </template>
                </el-table-column>
                <el-table-column prop="percentage" label="占比" align="center">
                </el-table-column> </el-table
            ></el-col>
            <el-col :span="8">
              <div id="main1" style="width: 600px; height: 400px"></div>
              <el-table
                :data="outList"
                v-loading="loading"
                style="width: 80%; margin-left: 15%; margin-top: 25px"
              >
                <el-table-column
                  prop="categoryName"
                  label="类型"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="totalMoney"
                  label="金额(元)"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ format_number(scope.row.totalMoney) }}
                  </template>
                </el-table-column>
                <el-table-column prop="percentage" label="占比" align="center">
                </el-table-column> </el-table
            ></el-col>
            <el-col :span="8">
              <div id="main2" style="width: 600px; height: 400px"></div>
              <el-table
                :data="payMethodList"
                v-loading="loading"
                style="width: 80%; margin-left: 15%; margin-top: 25px"
              >
                <el-table-column
                  prop="categoryName"
                  label="类型"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="totalMoney"
                  label="金额(元)"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ format_number(scope.row.totalMoney) }}
                  </template>
                </el-table-column>
                <el-table-column prop="percentage" label="占比" align="center">
                </el-table-column> </el-table
            ></el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="教练统计" name="coachStatistics"> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {
  getRevenueAndExpenditureStatistics,
  getRevenueAndExpenditureStatisticsForExcel,
} from "@/api/standingBookManagement.js";
import { getAntDeptSelect } from "../../api/BusinessManagement";
import { dateNowYear } from "../../utils/util";
export default {
  data() {
    return {
      activeName: "assemblyStorage",
      accountFrom: {
        dateEnd: dateNowYear(),
        dateStart: dateNowYear(),
        shopId: "",
        type: "customize",
      },
      mdSelectList: [],
      cashSurplus: "",
      totalExpenses: "",
      totalRevenue: "",
      intList: [],
      outList: [],
      payMethodList: [],
      intListChart: [],
      outListChart: [],
      payMethodListChart: [],
      showshopId: false,
      loading: false
    };
  },
  created() {
    this.accountFrom.shopId = this.$route.query.shopId;
  },
  mounted() {
    this.getRevenueAndExpenditureStatistics(this.accountFrom);
    this.getAntDeptSelect();
    this.isStoreManager();
  },
  methods: {
    changetab(tab) {
      if (tab.label == "订单流水") {
        this.$router.push({
          path: "/AccountManagement/assembly",
          query: { shopId: this.accountFrom.shopId },
        });
      } else if (tab.label == "教练统计") {
        this.$router.push({
          path: "/AccountManagement/coachStatistics",
          query: { shopId: this.accountFrom.shopId },
        });
      }
    },
    changeRadio(value) {
      if (value == "year") {
        this.accountFrom.dateStart = "2021";
        this.accountFrom.dateEnd = "";
      } else {
        this.accountFrom.dateStart = "";
        this.accountFrom.dateEnd = "";
      }
    },
    // 搜索
    accountSearch() {
      if (!this.accountFrom.dateStart) {
        this.$message({
          message: "请选择查询时间",
          type: "warning",
        });
      } else if (
        this.accountFrom.type == "customize" &&
        !this.accountFrom.dateEnd
      ) {
        this.$message({
          message: "请选择结束时间",
          type: "warning",
        });
      } else if (
        this.accountFrom.type == "customize" &&
        this.accountFrom.dateStart &&
        this.accountFrom.dateEnd &&
        new Date(this.accountFrom.dateStart).getTime() >
          new Date(this.accountFrom.dateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
      } else {
        this.getRevenueAndExpenditureStatistics(this.accountFrom);
      }
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无门店数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 收支列表
    getRevenueAndExpenditureStatistics(params) {
       this.loading = true;
      getRevenueAndExpenditureStatistics(params).then((res) => {
        // console.log(res);
          this.loading = false;
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无收支统计数据",
            });
          } else {
            this.intList = res.data.result.intList;
            this.outList = res.data.result.outList;
            this.payMethodList = res.data.result.payMethodList;
            this.totalRevenue = res.data.result.totalRevenue;
            this.totalExpenses = res.data.result.totalExpenses;
            this.cashSurplus = res.data.result.cashSurplus;
            this.initStart();
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    initStart() {
      this.intListChart = [];
      this.outListChart = [];
      (this.payMethodListChart = []),
        this.intList.map((item) => {
          this.intListChart.push({
            value: item.totalMoney,
            name: item.categoryName,
          });
        });
      this.outList.map((item) => {
        this.outListChart.push({
          value: item.totalMoney,
          name: item.categoryName,
        });
      });
      this.payMethodList.map((item) => {
        this.payMethodListChart.push({
          value: item.totalMoney,
          name: item.categoryName,
        });
      });
      this.init();
      this.init1();
      this.init2();
    },
    init() {
      let myChart = this.$echarts.init(document.getElementById("main"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} (元)",
        },
        legend: {
          width: "80%",
          orient: "horizontal",
          icon: "circle",
          y: "90%",
          itemWidth: 5, // 设置宽度
          itemHeight: 5, // 设置高度
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "收入",
            textAlign: "center",
            fill: "#333333",
            fontSize: 24,
            // fontWeight: 700,
          },
        },
        title: {
          text: this.format_number(this.totalRevenue) + "元",
          left: "center",
          top: "50%",
          textStyle: {
            color: "#333333",
            fontSize: 16,
            align: "center",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            // data: [
            //   { value: 2000, name: "会员办理" },
            //   { value: 2000, name: "会员储值" },
            //   { value: 2000, name: "饮料" },
            //   { value: 2000, name: "售后" },
            //   { value: 2000, name: "器材" },
            // ],
            // 饼图的边框
            //   itemStyle: {
            //     borderRadius: 10,
            //     borderColor: '#fff',
            //     borderWidth: 1
            // },
            data: this.intListChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    init1() {
      let myChart = this.$echarts.init(document.getElementById("main1"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} (元)",
        },
        legend: {
          width: "80%",
          orient: "horizontal",
          icon: "circle",
          y: "90%",
          itemWidth: 5, // 设置宽度
          itemHeight: 5, // 设置高度
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "支出",
            textAlign: "center",
            fill: "#333333",
            fontSize: 24,
            // fontWeight: 700,
          },
        },
        title: {
          text: this.format_number(this.totalExpenses) + "元",
          left: "center",
          top: "50%",
          textStyle: {
            color: "#333333",
            fontSize: 16,
            align: "center",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            // data: [{ value: 100, name: "退押金" }],
            data: this.outListChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    init2() {
      let myChart = this.$echarts.init(document.getElementById("main2"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} (元)",
        },
        legend: {
          width: "80%",
          orient: "horizontal",
          icon: "circle",
          y: "90%",
          itemWidth: 5, // 设置宽度
          itemHeight: 5, // 设置高度
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "合计",
            textAlign: "center",
            fill: "#333333",
            fontSize: 24,
            // fontWeight: 700,
          },
        },
        title: {
          text: this.format_number(this.cashSurplus) + "元",
          left: "center",
          top: "50%",
          textStyle: {
            color: "#333333",
            fontSize: 16,
            align: "center",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            data: this.payMethodListChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    // 导出
    copyOut() {
      if (!this.accountFrom.dateStart) {
        this.$message({
          message: "请选择查询时间",
          type: "warning",
        });
      } else if (
        this.accountFrom.type == "customize" &&
        !this.accountFrom.dateEnd
      ) {
        this.$message({
          message: "请选择结束时间",
          type: "warning",
        });
      } else if (
        this.accountFrom.type == "customize" &&
        this.accountFrom.dateStart &&
        this.accountFrom.dateEnd &&
        new Date(this.accountFrom.dateStart).getTime() >
          new Date(this.accountFrom.dateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
      } else {
        getRevenueAndExpenditureStatisticsForExcel(this.accountFrom).then(
          (res) => {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            let downloadElement = document.createElement("a");
            let href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            downloadElement.download = "收支统计";
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          }
        );
      }
    }, //如果是店长账号 只能看见自己门店的台账
    isStoreManager() {
      if (sessionStorage.roleCode === "storeManager") {
        this.accountFrom.shopId = sessionStorage.shopId;
        this.showshopId = true;
      }
    },
    // 科学计数法
    format_number(nStr) {
      nStr += ""; //数字转换为字符
      let x = nStr.split("."); //按照小数点分隔
      let x1 = x[0]; //整数部分
      let x2 = x.length > 1 ? "." + x[1] : ""; //小数部分
      let rgx = /(\d+)(\d{3})/; //正则式定义
      while (rgx.test(x1)) {
        //正则式匹配
        x1 = x1.replace(rgx, "$1" + "," + "$2"); //正则式替换
      }
      return x1 + x2;
    },
  },
};
</script>

<style scoped>
.ml15 {
  margin-left: 15px;
}
.ml20 {
  margin-left: 20px;
}
.colorRed {
  color: red;
}
.colorGreen {
  color: rgb(48, 162, 87);
}
.colorBlack {
  color: Black;
}
.fz18 {
  font-size: 18px;
  font-weight: 700;
}
.dFlex {
  display: flex;
  height: 50px;
  line-height: 50px;
  border: 1px solid #ccc;
  margin-top: 20px;
}
.accountMain {
  padding: 30px;
}
.mp {
  padding: 0 10px;
}
.rowWidth {
  width: 100%;
  overflow-x: scroll;
}
</style>
